import moment from "moment";


export const prepareBeneficiarios = async (benef = {}, idAreaUsuario, idSeccionalUsuario) => ({
  ...benef,
  fecha_nacimiento: createDateAsUTC(moment(benef.fecha_nacimiento).toDate()),
  fecha_alta: createDateAsUTC(moment(benef.fecha_alta).toDate()),
  //fecha_baja: moment(benef.fecha_baja).toDate(),
  fecha_fin_cobertura: createDateAsUTC(moment(benef.fecha_fin_cobertura).toDate()),
  fecha_certificado_discapacidad:  moment(benef.fecha_certificado_discapacidad).toDate(),
  //fecha_vigencia:  moment(benef.fecha_vigencia).toDate().toLocaleString('es-AR', { timeZone: 'America/Buenos_Aires' }),
  fecha_vigencia:  createDateAsUTC(moment(benef.fecha_vigencia).toDate()),
  fechaAviso:  createDateAsUTC(moment(benef.fechaAviso).toDate()),
  //incapacitado: benef.incapacitado === 'S' ? 1 : 0,
  cuil:parseInt(benef.cuil),
  nro_doc:parseInt(benef.nro_doc),
  cuil_familiaracargo : benef.cuil_familiaracargo === "" ? 0 : parseInt(benef.cuil_familiaracargo),
  id_plan:parseInt(benef.id_plan),
  idArea: idAreaUsuario,
  idSeccionalUsuario: idSeccionalUsuario,
  dpto: benef.depto,
});

const createDateAsUTC = (date) =>  {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}
// function convertDateToUTC(date) { 
//   return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()); 
// }
